module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-bold-8519c908898222d6b9fbd77dd8669d7a.svg";